import styles from './Card.module.scss'

export const Card = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { children, ...other } = props
  return (
    <div className={styles.container} {...other}>
      {children}
    </div>
  )
}

export default Card
